const getReturnableProductQuantities = (productDetails = {}) => {
  const productCodes = Object.keys(productDetails);

  const returnableProductQuantities =
    productCodes.length > 0
      ? productCodes.map(productCode => {
          const returnProductDetails = productDetails[productCode];
          const { sizes, returnable, totalReturnableQuantity } = returnProductDetails;
          const { wholesaleAmount } = productDetails[productCode] || 0;

          return { productCode, sizes, returnable, wholesaleAmount, totalReturnableQuantity };
        })
      : [];

  return returnableProductQuantities.filter(({ totalReturnableQuantity }) => totalReturnableQuantity > 0);
};

export default getReturnableProductQuantities;
